import React, { useContext } from "react";
import { View, Text, Linking, StyleSheet } from "react-native";
import {
  BG_STYLES,
  BORDER_STYLES,
  Button,
  BUTTON_STATUS,
  COLORS,
  COMMON_STYLES,
  LazyImage,
  SIZE,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";

import FileIcon from "app/icons/File";
import FallbackFarmImage from "./FallbackFarmImage";
import { ResponsiveContext } from "app/context/ResponsiveUIContext";
import { DIMENSION_WIDTH } from "app/utils/common";
import useGoogleMapImage from "app/hooks/useGoogleMapImage";

interface Props {
  farmIndex: number;
  farmImage: string;
  farmName: string;
  land: string;
  latLng: string;
  reportUrl: string | null;
  cropImage: string | null;
}

const FarmReportCard = ({
  farmIndex,
  farmImage,
  farmName,
  land,
  latLng = "",
  reportUrl,
  cropImage,
}: Props) => {
  const { mediaStyles } = useContext(ResponsiveContext);

  const [lat = 0, lang = 0] = latLng
    ?.split(",")
    .map((item) => Number(item || 0));

  const mapRef = useGoogleMapImage(lat, lang);

  return (
    <View>
      <View
        style={[
          COMMON_STYLES.b1,
          BORDER_STYLES.borderBlue20,
          BG_STYLES.bgWhite,
          COMMON_STYLES.br1,
          COMMON_STYLES.ofHidden,
          styles.card,
        ]}
      >
        <View style={[styles.header, COMMON_STYLES.relative]}>
          <View
            ref={mapRef as any}
            style={{
              height: "100%",
              width: "100%",
              borderRadius: 8,
              overflow: "hidden",
            }}
          />
          {/* <LazyImage
            imageUrl={farmImage}
            imgStyles={[
              COMMON_STYLES.fullHeight,
              COMMON_STYLES.fullWidth,
              COMMON_STYLES['br1/2'],
            ]}
            fallBackIcon={<FallbackFarmImage />}
          /> */}
          {/* {cropImage && (
            <LazyImage
              imageUrl={cropImage}
              imgStyles={[styles.cropImage, COMMON_STYLES.absolute]}
            />
          )} */}
          <View
            style={[
              COMMON_STYLES.absolute,
              BG_STYLES.bgBlack,
              COMMON_STYLES["opacity1/2"],
              COMMON_STYLES["ph1/2"],
              COMMON_STYLES["pv1/4"],
              styles.farmCountLabel,
            ]}
          >
            <Text
              style={[
                TYPOGRAPHY.TEXT2,
                VARIANTS_STYLES.MEDIUM,
                TEXT_STYLES.textWhite,
              ]}
            >
              Farm {farmIndex + 1}
            </Text>
          </View>
        </View>

        <View style={[COMMON_STYLES.ph1, COMMON_STYLES.pb1]}>
          <Text
            style={[
              TYPOGRAPHY.TEXT1,
              VARIANTS_STYLES.SEMI_EMPHASIZED,
              TEXT_STYLES.textNeutral80,
            ]}
          >
            {farmName}
          </Text>
          <Text
            style={[
              TYPOGRAPHY.TEXT2,
              VARIANTS_STYLES.MEDIUM,
              TEXT_STYLES.textNeutral80,
            ]}
          >
            {land || "Land Area: --"}
          </Text>
          <Text
            style={[
              TYPOGRAPHY.TEXT2,
              VARIANTS_STYLES.MEDIUM,
              TEXT_STYLES.textNeutral80,
            ]}
          >
            Coordinates: {`${lat?.toFixed(5)}, ${lang?.toFixed(5)}`}
          </Text>
        </View>
      </View>
      <Button
        onClick={() => reportUrl && Linking.openURL(reportUrl)}
        text={"View Reports"}
        buttonStyle={COMMON_STYLES["mt1/2"]}
        textStyle={[TYPOGRAPHY.TEXT2, VARIANTS_STYLES.MEDIUM]}
        size={SIZE.large}
        iconLeft={<FileIcon />}
        status={reportUrl ? BUTTON_STATUS.ACTIVE : BUTTON_STATUS.DISABLED}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    width: Math.min(292, DIMENSION_WIDTH - 48),
  },
  header: {
    height: 171,
    margin: 8,
  },
  cropImage: {
    height: 48,
    width: 48,
    borderRadius: 24,
    bottom: -24,
    right: 16,
    borderWidth: 1,
    borderColor: COLORS.neutral10,
  },
  farmCountLabel: {
    borderTopLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
});

export default FarmReportCard;
